import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardFilterCounter } from "../filters/StandardFilterCounter"
import { StandardButton } from "../buttons/StandardButton"

export const StandardFilterButton = ({
    onClick,
    activeCount,
    className,
}: {
    onClick: () => void
    activeCount: number
    className?: string
}) => {
    return (
        <StandardButton fullWidth={false} size="small" variant="outlined" onClick={onClick} className={className}>
            <LocalizedStrict id="table-filters-button">
                <>Filters</>
            </LocalizedStrict>
            <StandardFilterCounter show={Boolean(activeCount)} counter={activeCount} />
        </StandardButton>
    )
}
